<vg-card-giftcard [img]="img">
    <h3 class="title">{{ title }}</h3>
</vg-card-giftcard>
